export default class AccountsReceivableNumberConfig {
    static fromData(data) {
        if (!data) {
            return;
        }

        const config = new AccountsReceivableNumberConfig();
        config.initialCounter = data.initialCounter;
        config.maxCounter = data.maxCounter;

        return config;
    }

    serialize() {
        return {
            initialCounter: this.initialCounter,
            maxCounter: this.maxCounter,
        };
    }
}
